// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import Loader from '../../../common/Loader';
import RoiKpi from './RoiKpi';
import {
  computePayback,
  formatMgr,
  formatPayback,
  formatRoi,
  formatRoiParam,
  formatTic,
} from '../../../../utils/formatUtils';
import type { RoiResult } from '../../../../types/apolloType';

type Props = {
  resultLoading: boolean,
  title: string,
  titleDetails: string,
  roiSuggestionResult: RoiResult,
  focus: string,
  showDetails: any,
}

function RoiPanelResult(props: Props) {
  const getContent = () => {
    if (props.resultLoading) {
      return (
        <Loader isLoading message={<Translate value="roi.computing" />} />
      );
    }
    if (props.roiSuggestionResult) {
      return (
        <>
          <div className="roi-result">
            <RoiKpi
              kpiValue={formatRoi(
                props.roiSuggestionResult.roi,
                props.roiSuggestionResult.netMgrGlaUplift,
                props.roiSuggestionResult.tic,
              )}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={
                formatPayback(computePayback(
                  props.roiSuggestionResult.netMgrGlaUplift,
                  props.roiSuggestionResult.tic,
                ))
              }
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatMgr(props.roiSuggestionResult.roiParams.newMgr, 0)}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatMgr(props.roiSuggestionResult.netMgrGlaUplift, 0)}
              isFocus={props.focus === 'mgr'}
              isPositive={props.roiSuggestionResult.netMgrGlaUplift > 0}
            />
            <RoiKpi
              kpiValue={formatTic(props.roiSuggestionResult.tic, 0)}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatTic(props.roiSuggestionResult.roiParams.keyMoney, 0)}
              isFocus={props.focus === 'keymoney'}
              isPositive={props.roiSuggestionResult.roiParams.keyMoney > 0}
            />
            <RoiKpi
              kpiValue={
                formatRoiParam(props.roiSuggestionResult.valueCreationVsCurrent, 0)
              }
              isFocus={false}
            />
            <RoiKpi
              kpiValue={
                formatTic(props.roiSuggestionResult.roiParams.rentIncentives, 0)
              }
              isFocus={props.focus === 'incentives'}
              isPositive={props.roiSuggestionResult.roiParams.rentIncentives > 0}
            />
          </div>
          <div className="roi-button-container">
            <button
              type="button"
              className="apollo-button-contained details-button"
              onClick={() => props.showDetails(true)}
            >
              <div className="button-big-text">
                <Translate value="roi.details" />
              </div>
            </button>
          </div>
        </>
      );
    }
    return (
      <div className="roi-result" />
    );
  };
  return (
    <div className="roi-panel roi-panel-kpi">
      <h3 className="roi-subtitle">
        <Translate value={props.title} />
        <Translate className="subtitle-details" value={props.titleDetails} />
      </h3>
      <div className="roi-panel-content">
        {getContent()}
      </div>
    </div>
  );
}

export default RoiPanelResult;
